if (!customElements.get('product-slider')) {
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
      this.mainSwiper = null;
      this.thumbsSwiper = null;
      this.isDesktop = window.innerWidth >= 1100;
      this.currentSlide = 1;
      this.totalSlides = 0;
    }

    connectedCallback() {
      this.init();
      this.setupResizeListener();
    }

    init() {
      this.isDesktop = window.innerWidth >= 1100;
      this.totalSlides = this.querySelectorAll('.swiper-slide').length;
      
      if (this.isDesktop) {
        this.initDesktopSlider();
      } else {
        this.initMobileSlider();
      }
    }

    initDesktopSlider() {
      const thumbsContainer = this.querySelector('.product-slider__desktop .product-slider__thumbs');
      const mainContainer = this.querySelector('.product-slider__desktop .product-slider__main');
      
      if (!thumbsContainer || !mainContainer) {
        console.error('Desktop slider containers not found');
        return;
      }

      // Initialize thumbs slider first
      this.thumbsSwiper = new Swiper(thumbsContainer, {
        direction: 'vertical',
        slidesPerView: 3,
        spaceBetween: 10,
        navigation: {
          nextEl: this.querySelector('.thumbs-button-next'),
          prevEl: this.querySelector('.thumbs-button-prev'),
        },
        on: {
          slideChange: () => {
            if (this.mainSwiper) {
              this.mainSwiper.slideTo(this.thumbsSwiper.activeIndex);
            }
          }
        }
      });

      // Initialize main slider with thumbs connection
      this.mainSwiper = new Swiper(mainContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        thumbs: {
          swiper: this.thumbsSwiper
        },
        on: {
          slideChange: () => {
            if (this.thumbsSwiper) {
              this.thumbsSwiper.slideTo(this.mainSwiper.activeIndex);
            }
          }
        }
      });
    }

    initMobileSlider() {
      const mainContainer = this.querySelector('.product-slider__mobile .product-slider__main');
      
      if (!mainContainer) {
        console.error('Mobile slider container not found');
        return;
      }

      this.mainSwiper = new Swiper(mainContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        on: {
          slideChange: () => {
            // this.updateSlideCounter();
          }
        }
      });

      // this.updateSlideCounter();
    }

    updateSlideCounter() {
      const counter = this.querySelector('.slide-counter');
      if (counter) {
        this.currentSlide = this.mainSwiper.activeIndex + 1;
        counter.textContent = `${this.currentSlide} / ${this.totalSlides}`;
      }
    }

    setupResizeListener() {
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const wasDesktop = this.isDesktop;
          this.isDesktop = window.innerWidth >= 1100;
          
          if (wasDesktop !== this.isDesktop) {
            this.destroySliders();
            this.init();
          }
        }, 250);
      });
    }

    destroySliders() {
      if (this.mainSwiper) {
        this.mainSwiper.destroy(true, true);
        this.mainSwiper = null;
      }
      if (this.thumbsSwiper) {
        this.thumbsSwiper.destroy(true, true);
        this.thumbsSwiper = null;
      }
    }

    disconnectedCallback() {
      this.destroySliders();
    }
  }

  customElements.define('product-slider', ProductSlider);
}